export default __webpack_public_path__ + "static/media/community.9ceeb12f.png";